import { LinearProgress, styled } from '@mui/material';

export const BorderLinearProgress = styled(LinearProgress)(() => ({
  height: 14,
  borderRadius: 5,
}));
